(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  var title = container && container.querySelector('.shopify-policy__title');
  var body = container && container.querySelector('.shopify-policy__body');

  if (!container || !title || !body || container.dataset.kolderPolicyReady === 'true') return;

  container.dataset.kolderPolicyReady = 'true';

  var path = window.location.pathname;
  var isPrivacy = path.indexOf('/privacy-policy') !== -1;
  var eyebrow = document.createElement('span');
  var intro = document.createElement('p');

  eyebrow.className = 'kolder-policy__eyebrow';
  eyebrow.textContent = 'Información legal KOLDER';
  intro.className = 'kolder-policy__intro';
  intro.textContent = isPrivacy
    ? 'Conoce cómo recopilamos, utilizamos y protegemos la información relacionada con tu experiencia en KOLDER.'
    : 'Consulta las condiciones que regulan el uso de nuestro sitio, nuestros servicios y tus compras en KOLDER.';

  title.insertBefore(eyebrow, title.firstChild);
  title.appendChild(intro);

  var headings = Array.prototype.slice.call(body.querySelectorAll('.rte h2, .rte h3'));
  var usedIds = {};

  function slugify(value) {
    var base = value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'seccion';
    var slug = base;
    var count = 2;

    while (usedIds[slug] || document.getElementById(slug)) {
      slug = base + '-' + count;
      count += 1;
    }

    usedIds[slug] = true;
    return slug;
  }

  headings.forEach(function (heading) {
    if (!heading.id) heading.id = slugify(heading.textContent.trim());
    usedIds[heading.id] = true;
  });

  var sidebar = document.createElement('aside');
  sidebar.className = 'kolder-policy__sidebar';
  sidebar.setAttribute('aria-label', 'Navegación de información legal');

  var sidebarInner = document.createElement('div');
  sidebarInner.className = 'kolder-policy__sidebar-inner';

  var switcher = document.createElement('nav');
  switcher.className = 'kolder-policy__switcher';
  switcher.setAttribute('aria-label', 'Políticas de KOLDER');
  switcher.innerHTML =
    '<a href="/policies/terms-of-service"' + (!isPrivacy ? ' aria-current="page"' : '') + '>Términos y condiciones</a>' +
    '<a href="/policies/privacy-policy"' + (isPrivacy ? ' aria-current="page"' : '') + '>Política de privacidad</a>';
  sidebarInner.appendChild(switcher);

  if (headings.length) {
    var navHeading = document.createElement('h2');
    navHeading.className = 'kolder-policy__nav-heading';
    navHeading.textContent = 'Contenido de esta página';
    sidebarInner.appendChild(navHeading);

    var nav = document.createElement('ol');
    nav.className = 'kolder-policy__nav';

    var mobileNav = document.createElement('div');
    mobileNav.className = 'kolder-policy__mobile-nav';
    var selectId = 'kolder-policy-section';
    var label = document.createElement('label');
    var select = document.createElement('select');

    label.setAttribute('for', selectId);
    label.textContent = 'Ir a una sección';
    select.id = selectId;
    select.setAttribute('aria-label', 'Ir a una sección de esta política');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Selecciona una sección';
    select.appendChild(placeholder);

    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var option = document.createElement('option');
      var text = heading.textContent.trim();

      link.href = '#' + heading.id;
      link.textContent = text;
      link.dataset.target = heading.id;
      item.appendChild(link);
      nav.appendChild(item);

      option.value = heading.id;
      option.textContent = text;
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      if (!select.value) return;
      var target = document.getElementById(select.value);
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });

    mobileNav.appendChild(label);
    mobileNav.appendChild(select);
    sidebarInner.appendChild(mobileNav);
    sidebarInner.appendChild(nav);

    if ('IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) {
            link.classList.toggle('is-active', link.dataset.target === entry.target.id);
          });
          select.value = entry.target.id;
        });
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });

      headings.forEach(function (heading) { observer.observe(heading); });
    }
  }

  sidebar.appendChild(sidebarInner);
  container.insertBefore(sidebar, body);
})();
